import axios from '../api/index.js';

//查询字典列表
export let getDict = (params) => {
    return axios.post(`/perform/news/dict/list`,params);
};

//获取字典列表分页
export let getDictPageList = (params) => {
    return axios.post(`/perform/news/dict/pageList`,params);
};

//获取字典详情
export let getDictDetail = (params) => {
    return axios.get(`/perform/news/dict/${params}`);
};



// WEBPACK FOOTER //
// ./src/api/dict.js